import { useAtSize } from '@fs/zion-ui'

export default function useIsMobile(breakpoint = 'lg') {
  const atSize = useAtSize()
  return atSize({
    [breakpoint]: false,
    default: true,
  })
}
